<header>
    <app-header isWavier=true headerName="Parking Details"></app-header>
  </header>
  <section class="parking-wrapper">
    <div class="outer-conatiner" >
        <div class="inner-container">
          <app-page-title pageTitle='Overnight Parking Waiver Request'></app-page-title>
           <form [formGroup]="parkingForm" (ngSubmit)="onSubmit()">
           <div class="container-wrapper">
            <div class="row">
            <div class="col-6 row-cols">
            <mat-form-field >
                <mat-label>License Plate State<span class="required-asterisk">*</span></mat-label>
                <mat-select formControlName="stateId">
                  <mat-option *ngFor="let state of states" [value]="state.id">{{state.state}}</mat-option>
                </mat-select>
                 <!-- <input matInput name="state" formControlName="state"/> -->
                 <mat-error *ngIf="parkingForm.get('stateId').hasError('required')">
                  Please select state
                </mat-error> 
              </mat-form-field>
              </div>
              <div class="col-6 row-cols " style="text-align: left;">
              <mat-form-field >
                 <mat-label>License Plate #<span class="required-asterisk">*</span></mat-label>
                 <input matInput formControlName="plateNo" pattern="^[a-zA-Z0-9\-_]{0,40}$"/> 
                 <mat-error *ngIf="parkingForm.get('plateNo').hasError('required')">
                  Please enter plate number
                </mat-error> 
                <mat-error  *ngIf="!parkingForm.get('plateNo').hasError('required') && parkingForm.get('plateNo').hasError('pattern')">
                  Plate.No. should be without spaces.
                </mat-error>
              </mat-form-field>
              <span class="special-txt" style="color:#888">If you have a specialty license plate, please make sure to include the two letter suffix as shown on your vehicle registration card.</span>
              </div>
            </div>
              <div class="row">
               <div class="col-6 row-cols"> 
                <mat-form-field  class="">
                    <mat-label>Parking Date<span class="required-asterisk">*</span></mat-label>
                    <input  matInput formControlName="startDate" (click)="picker.open()" [matDatepicker]="picker" [min]="todayDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="parkingForm.get('startDate').hasError('required')">
                      Please enter parking date
                    </mat-error> 
                  </mat-form-field> 
               </div>
               <div class="col-6 row-cols" style="text-align: left;padding-top:12px;">
                <span class="special-txt">Please make sure the date you select is the date you plan to park on the street between 2:00 A.M. – 6:00 A.M. If you plan to park on the street tonight between 2:00 A.M. – 6:00 A.M., select tomorrow’s date.</span>

                <!-- <mat-form-field  class="">
                    <mat-label>End Date<span class="required-asterisk">*</span></mat-label>
                    <input matInput formControlName="endDate" [matDatepicker]="picker1"
                    [min]="parkingForm.controls['startDate'].value? parkingForm.controls['startDate'].value : maxDate" [max]='maxDate'>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                    <mat-error *ngIf="parkingForm.get('endDate').hasError('required')">
                      Please enter end date
                    </mat-error> 
                  </mat-form-field>
               </div> -->
               <!-- <div class="col-1">
                   <button class="add-dates" (click)="addDates()"><span class="material-icons plus-icon">
                    add
                    </span></button>
               </div> -->
              <!-- </div> -->
              <!-- <div class="row" *ngFor="let date of dynamicDate;let i=index">
                <div class="col-6">
                    <h1>{{i}}{{i+1}}</h1>
                    <mat-form-field appearance="fill" class="mat-date-pick">
                        <mat-label>Choose a date</mat-label>
                        <input matInput [matDatepicker]=ii >
                        <mat-datepicker-toggle matSuffix [for]=ii></mat-datepicker-toggle>
                        <mat-datepicker #ii></mat-datepicker>
                      </mat-form-field>
                   </div>
                   <div class="col-6">
                    <mat-form-field appearance="fill" class="mat-date-pick">
                        <mat-label>Choose a date</mat-label>
                        <input matInput [matDatepicker]=i+1>
                        <mat-datepicker-toggle matSuffix [for]=i+1></mat-datepicker-toggle>
                        <mat-datepicker #i+1></mat-datepicker>
                      </mat-form-field>
                   </div>-->
              </div> 
              </div>
              <mat-form-field>
                <mat-label>Reason<span class="required-asterisk">*</span></mat-label>
                <mat-select formControlName="reasonId" >
                  <mat-option *ngFor="let reason of reasons" [value]="reason.id" >{{reason.reason}}</mat-option>
                </mat-select>
                <mat-error *ngIf="parkingForm.get('reasonId').hasError('required')">
                  Please enter reason
                </mat-error> 
              </mat-form-field>
              <mat-form-field *ngIf="otherReason && (parkingForm.controls.reasonId.value == otherReason[0].id)">
                 <mat-label>Other reason</mat-label>
                 <input matInput formControlName="otherReason"/>
                 <mat-error *ngIf="parkingForm.get('otherReason').hasError('required')">
                  Please provide additional information
                </mat-error> 
              </mat-form-field>
              <p class="sub-form-title padding-30">Address Where You Will Be Parking</p>
              <div class="row">
                <div class="col-6 row-cols">
                  <mat-form-field  class="">
                    <mat-label>Street No.<span class="required-asterisk">*</span></mat-label>
                    <input matInput formControlName="streetNumber"/>
                    <mat-error *ngIf="parkingForm.get('streetNumber').hasError('required')">
                      Please enter steet number
                    </mat-error> 
                  </mat-form-field>
                </div>
                <div class="col-6 row-cols">
              <mat-form-field >
                 <mat-label>Street<span class="required-asterisk">*</span></mat-label>
                 <mat-select formControlName="streetId">
                   <mat-option *ngFor="let street of streets" [value]="street.id">{{street.street}}</mat-option>
                 </mat-select>
                 <mat-error *ngIf="parkingForm.get('streetId').hasError('required')">
                  Please enter street
                </mat-error> 
               </mat-form-field>
               </div>
               <!-- <div class="col-6 row-cols">
               <mat-form-field >
                 <mat-label>Street No.<span class="required-asterisk">*</span></mat-label>
                 <mat-select formControlName="streetNoId">
                  <mat-option *ngFor="let streetNo of streetNumbers" [value]="streetNo.id">{{streetNo.streetNo}}</mat-option>
                </mat-select>
                 <mat-error *ngIf="parkingForm.get('streetNoId').hasError('required')">
                  Please enter Street number
                </mat-error> 
               </mat-form-field>
               </div> -->
               </div>
               <!-- <div class="row">
                <div class="col-6 row-cols">
               <mat-form-field >
                <mat-label>City<span class="required-asterisk">*</span></mat-label>
                <input matInput formControlName="city"/>
                <mat-error *ngIf="parkingForm.get('city').hasError('required')">
                  Please enter City
                </mat-error> 
              </mat-form-field>
              </div>
              <div class="col-6 row-cols">
              <mat-form-field >
                <mat-label>Zipcode<span class="required-asterisk">*</span></mat-label>
                <input matInput formControlName="zipcode"/>
                <mat-error *ngIf="parkingForm.get('zipcode').hasError('required')">
                  Please enter Zipcode
                </mat-error> 
              </mat-form-field>
              </div>
              </div> -->
              <p>Citations issued between 2:00 A.M. - 6:00 A.M. will not be waived if the citation is issued prior to the
                time an overnight parking waiver is requested. Vehicles MUST be parked legally (i.e. not in front of a fire
                hydrant, mailbox, etc.).
                Waivers are not valid when snowfall exceeds 2".
                For questions about overnight parking or parking restrictions, please visit <a href="http://www.villageofvolo.com/parking" target="_blank">www.villageofvolo.com/parking </a>.
              </p>
              <button mat-button class="button-primary" [disabled]='parkingForm.invalid || btndisabled'  color="vov-ui-primary">Submit</button>
           </div>
         </form>
        </div>
     </div>
  </section>
